import { withLoyaltyStore } from "../../utils/withLoyaltyStore";

import { SimplifiedPrizes as SimplifiedPrizesBase } from "./SimplifiedPrizes";
import { SimplifiedPrizesV2 as SimplifiedPrizesV2Base } from "./SimplifiedPrizesV2";

export type * from "./SimplifiedPrizes";
export type * from "./SimplifiedPrizesV2";
export const SimplifiedPrizes = withLoyaltyStore(SimplifiedPrizesBase, "SimplifiedPrizes");
export const SimplifiedPrizesV2 = withLoyaltyStore(SimplifiedPrizesV2Base, "SimplifiedPrizesV2");
